import type { ReactNode } from "react";

export type MemoViewSvgProps = {
  lines: readonly string[];
  width: number;
  height: number;
  fontSize: number;
  lineHeight: number;
  padding: number;
  paddingY?: number;
  radius: number;
  borderWidth: number;
  borderColor: string;
  background?: string;
  textAlign?: "center";
};

/** Draws the entire read-only memo; editing remains in the surrounding MemoView. */
export default function MemoViewSvg(props: MemoViewSvgProps) {
  const { lines, width, height, fontSize, lineHeight, padding, radius, borderWidth, borderColor, background = "white" } = props;
  const textLines: ReactNode[] = [];
  for (let index = 0; index < lines.length; index++) {
    textLines.push(<text key={index} x={props.textAlign === "center" ? width / 2 : padding} y={lineHeight * index + (props.paddingY === undefined ? lineHeight * 0.25 + fontSize : props.paddingY + fontSize * 0.9)}
      textAnchor={props.textAlign === "center" ? "middle" : undefined}
      fontFamily="Helvetica, Arial, sans-serif" fontWeight="normal" fontSize={fontSize} fill="#000" xmlSpace="preserve">{lines[index]}</text>);
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}
      viewBox={`0 0 ${width} ${height}`} style={{ display: "block" }}>
      <rect x={borderWidth / 2} y={borderWidth / 2} width={Math.max(0, width - borderWidth)}
        height={Math.max(0, height - borderWidth)} rx={radius} fill={background}
        stroke={borderColor} strokeWidth={borderWidth} />
      {textLines}
    </svg>
  );
}
